'use client'

import { useAddProfileDialogStore } from '@/stores/addProfileDialogStore'

import { ProfileOnboardingDialog } from './ProfileOnboardingDialog'

/**
 * Globally-mounted host for the closeable "add a profile" dialog, opened from the
 * user menu. Kept separate from the forced onboarding gate (different lifecycle:
 * this one is dismissable).
 */
export const AddProfileDialogHost = () => {
  const open = useAddProfileDialogStore((state) => state.open)
  const closeDialog = useAddProfileDialogStore((state) => state.closeDialog)

  if (!open) {
    return null
  }

  return <ProfileOnboardingDialog closable onClose={closeDialog} />
}
